import { navItems } from "@/mocks/site";
import { goSection } from "./bits";

export default function Footer() {
  return (
    <footer className="border-t-4 border-primary-600 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                goSection("hero");
              }}
              className="inline-flex items-center gap-3"
              aria-label="每日大瓜首页"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-600 font-heading text-xl font-black text-background-50">
                瓜
              </span>
              <span className="leading-none">
                <span className="block font-heading text-2xl font-black text-foreground-950">每日大瓜</span>
                <span className="mt-1 block font-en text-[10px] uppercase tracking-[0.3em] text-primary-600">
                  Daily Gua
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注顶流塌房预警与法制咖锤合集，持续跟进税务问题爆料、合同纠纷内幕与行业潜规则曝光，提供可核验的实锤证据链，陪你理性吃瓜。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-fill", "ri-youtube-line", "ri-mail-fill", "ri-global-line"].map((ic) => (
                <a
                  key={ic}
                  href="#hero"
                  onClick={(e) => {
                    e.preventDefault();
                    goSection("hero");
                  }}
                  aria-label="官方社媒"
                  className="flex h-9 w-9 items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-500 transition hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={ic} />
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-en text-xs uppercase tracking-[0.24em] text-primary-600">快速导航</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {navItems.map((n) => (
                <li key={n.id}>
                  <button
                    type="button"
                    onClick={() => goSection(n.id)}
                    className="text-sm text-foreground-600 transition hover:text-primary-600"
                  >
                    {n.label}
                  </button>
                </li>
              ))}
              <li>
                <button
                  type="button"
                  onClick={() => goSection("contact")}
                  className="text-sm text-foreground-600 transition hover:text-primary-600"
                >
                  爆料投稿
                </button>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-en text-xs uppercase tracking-[0.24em] text-primary-600">内容准则</h4>
            <p className="mt-4 text-[13px] leading-relaxed text-foreground-500">
              本站在公开展示内容中不针对具体个人作主观定性；涉事主体默认采用角色化表述。所有“待核实”信息均会明确标注，最终结论请以司法机关及权威官方通报为准。读者如有异议，可联系我们核实与更正。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-foreground-600">
              <i className="ri-mail-line text-primary-500" /> gua@meiridagua.example.com
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-200">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 每日大瓜 · Daily Gua. 仅作资讯整理，不构成任何指控。</p>
          <p className="font-en tracking-widest text-foreground-400">FROM TEASER TO VERDICT · STAY INFORMED</p>
        </div>
      </div>
    </footer>
  );
}